





























































import Vue from "vue";

export default Vue.extend({
  name: "App",
  data: () => ({
    drawer: false,
  }),
  beforeCreate() {
    document.title = `E-Portfolio: ${this.$store.state.profile.userData.name}`;
  },
  computed: {
    currentPath() {
      return this.$router.currentRoute.path;
    },
    title() {
      return this.$store.state.navbar.title;
    },
    icon() {
      return this.$store.state.navbar.icon;
    },
  },
  methods: {
    toggleDarkMode: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
  },
  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
      if (theme == "true") {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    }
  },
});
